<script setup>
import { ref, computed } from 'vue'
import Width from "@/pages/Index/Width.vue";
import Title from "@/components/Title/Title.vue";

const props = defineProps({
	title: String,
	bgImage: String
})

</script>

<template>
	<div
		class="page-head"
		:style="{
			'background-image': `url(${props.bgImage})`
		}"
	>
		<div class="page-head__content">
			<Width>
				<Title
					:title="title"
					position="left"
					size="large"
				/>
			</Width>
		</div>
	</div>
</template>

<style scoped lang="less">
.page-head {
	background-size: cover;
	background-repeat: no-repeat;
	
	&__content {
		padding: 230px 0 151px 0;
	}
	
}

@media only screen and (max-width: 1024px) {
	.page-head {
		
		&__content {
			padding: 64px 40px 74px 40px;
		}
		
	}
}
</style>